import { formatISODate } from '@utils/date';

export const formatFormCreatedDate = (isoDate: string): string =>
  formatISODate({
    date: isoDate,
    format: 'dd-mm-yyyy',
    separator: '/'
  });

export const formatFormRegistrationCloseDate = (isoDate: string): string =>
  formatISODate({
    date: isoDate,
    format: 'MMM DD, YYYY'
  });

export const formatFormVersionLabel = (version: number): string =>
  `V${version}`;

export const toFormCloseDateIso = (date: Date): string => {
  const endOfDay = new Date(date);
  endOfDay.setHours(23, 59, 59, 999);
  return endOfDay.toISOString();
};
